// removed by extract-text-webpack-plugin
module.exports = {"fixedHeaderGrid":"_3DzAH"};


//////////////////
// WEBPACK FOOTER
// ./admin/permissions/components/FixedHeaderGrid.css
// module id = 2039
// module chunks = 3